// This method is dangerous as it can lead to error: Converting circular structure to JSON
// Use lodash instead:
// import _ from 'lodash';
// ...
// _.cloneDeep(obj)
import { PostCrAndRelevesAndPrimesRequest } from '../providers/activites/post-cr.service';

export function deepCopy<T>(obj: T): T | null {
  if (!obj) return null;
  return JSON.parse(JSON.stringify(obj));
}

export function copyPostCrForLog(postCr: PostCrAndRelevesAndPrimesRequest) {
  let postCrForLog = deepCopy(postCr);
  postCrForLog.cr.photos_client?.forEach((photo) => {
    photo.contenu = null;
  });
  postCrForLog.cr.piece_jointes?.forEach((pj) => (pj.base64Content = null));
  return postCrForLog;
}
